import APITemplate from '@api/APITemplate'
import { diffTimeMinutes, possivelJSON } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { minhaCarteira } from '@constants/URL'

class APIFinancialPlanningInvestmentAccounts extends APITemplate {
  constructor() {
    super()
    this.reqCarregar = {}
  }

  _shouldSkipLoad(clientId, forceUpdate) {
    if (!clientId) {
      return { status: 400, message: 'Cliente não informado.' }
    }

    const storedClientId =
      store.getters['financialPlanning/investmentAccountsClientId']

    if (!forceUpdate && String(storedClientId) === String(clientId)) {
      const shouldUpdate = diffTimeMinutes(
        store.getters['financialPlanning/investmentAccountsLastUpdate'],
        MINUTES_TIMEOUT_REQUESTS
      )

      if (!shouldUpdate) {
        return store.getters['financialPlanning/investmentAccounts']
      }
    }

    if (store.getters['financialPlanning/investmentAccountsLoading']) {
      return store.getters['financialPlanning/investmentAccounts']
    }

    return null
  }

  _handleResponse(response, clientId) {
    if (response && response.status === 200) {
      const parsedValue = possivelJSON(response.value)
      const items = Array.isArray(parsedValue)
        ? parsedValue.filter((item) => item && item.nome !== 'Outros')
        : []

      store.dispatch('financialPlanning/setInvestmentAccounts', {
        items,
        clientId,
      })
    } else {
      store.dispatch('financialPlanning/setInvestmentAccounts', {
        items: [],
        clientId: null,
      })
    }
  }

  async _executeCarregar(clientId, requestKey, requestUrl) {
    store.dispatch('financialPlanning/setInvestmentAccountsLoading', true)
    this.reqCarregar[requestKey] = con.get(requestUrl)

    try {
      const response = await this.reqCarregar[requestKey]
      this._handleResponse(response, clientId)
      return response
    } catch (error) {
      this._handleResponse(null, clientId)
      throw error
    } finally {
      store.dispatch('financialPlanning/setInvestmentAccountsLoading', false)
      delete this.reqCarregar[requestKey]
    }
  }

  async carregar({ clientId, forceUpdate = false } = {}) {
    const skipResult = this._shouldSkipLoad(clientId, forceUpdate)
    if (skipResult) return skipResult

    const requestKey = String(clientId)

    if (this.reqCarregar[requestKey]) {
      return this.reqCarregar[requestKey]
    }

    const url = `${minhaCarteira.cliente.bancos}/${clientId}`
    const response = await this._executeCarregar(clientId, requestKey, url)

    return response || {}
  }
}

const apiFinancialPlanningInvestmentAccounts =
  new APIFinancialPlanningInvestmentAccounts()

export { apiFinancialPlanningInvestmentAccounts }
